import { TPlanKeys } from './plan-keys.type';

export const planKeys: TPlanKeys[] = ['med', 'refer', 'labs', 'monitor', 'other'];
